var _createReducer;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";
import _ from "lodash";

var _createActions = createActions({
  addGlobalProps: ["options"],
  updateGlobalProps: ["options"],
  logout: [],
  saveGlobalProps: function saveGlobalProps(options) {
    return function (dispatch, getState) {
      dispatch(Creators.addGlobalProps(options));
    };
  },
  setGlobalProps: function setGlobalProps(options) {
    return function (dispatch) {
      dispatch(Creators.updateGlobalProps(options));
    };
  }
}),
    Types = _createActions.Types,
    Creators = _createActions.Creators;
/* ------------- Initial State ------------- */


export var INITIAL_STATE = Immutable({
  globalProps: {}
});
/* ------------- Reducers ------------- */

export var addGlobalProps = function addGlobalProps(state, _ref) {
  var options = _ref.options;
  return Immutable.merge(state, {
    globalProps: _extends({}, options)
  });
};
export var logout = function logout(state) {
  if (state === void 0) {
    state = INITIAL_STATE;
  }

  return state.merge({
    username: null,
    password: null
  });
};
export var updateGlobalProps = function updateGlobalProps(state, _ref2) {
  var _state$globalProps$pr;

  var options = _ref2.options;
  var presenceObj = ((_state$globalProps$pr = state.globalProps.presenceExt) === null || _state$globalProps$pr === void 0 ? void 0 : _state$globalProps$pr.asMutable()) || {};
  state = state.setIn(["globalProps", "to"], options.to);
  state = state.setIn(["globalProps", "chatType"], options.chatType);
  state = state.setIn(["globalProps", "name"], options.name);

  if (Object.keys(presenceObj).length) {
    for (var item in presenceObj) {
      for (var val in options.presenceExt) {
        if (item === val) {
          presenceObj[item] = _extends({}, presenceObj[item], options.presenceExt[val]);
        }

        if (!presenceObj[val]) {
          presenceObj[val] = options.presenceExt[val];
        }
      }
    }
  } else {
    presenceObj = options.presenceExt;
  }

  state = state.setIn(["globalProps", "presenceExt"], presenceObj);
  return state;
};
/* ------------- Hookup Reducers To Types ------------- */

export var globalPropsReducer = createReducer(INITIAL_STATE, (_createReducer = {}, _createReducer[Types.ADD_GLOBAL_PROPS] = addGlobalProps, _createReducer[Types.UPDATE_GLOBAL_PROPS] = updateGlobalProps, _createReducer[Types.LOGOUT] = logout, _createReducer));
export default Creators;